/**
 * listinfoBinding — MÀN HÌNH NÀY CHẠY THEO HÀNH VI SERVER CỦA LISTINFO NÀO.
 *
 * `data_list_config` là cấu hình GIAO DIỆN THUẦN: nó KHÔNG có phần xử lý server. Mọi xử lý riêng của
 * từng loại chứng từ — phân quyền, danh sách trạng thái, hook sự kiện phía server, ghi sổ — nằm ở
 * `listinfo` và được chọn bằng MÃ LISTINFO gửi kèm header `Listinfo-Code`.
 *
 * Hai điều dễ hiểu nhầm (đã hiểu nhầm một lần):
 *  1. `moduleCode` là mã MÀN HÌNH, `listinfo.code` là mã HÀNH VI SERVER. Hai thứ khác nhau. Trùng nhau
 *     chỉ là trường hợp phổ biến, không phải ràng buộc.
 *  2. NHIỀU listinfo dùng CHUNG một `api_code` mà vẫn có xử lý riêng — mã listinfo là thứ phân biệt.
 *     Không gửi mã nào thì API chạy HÀNH VI CHUẨN của nó (xem createHandler.js: nó tự lùi về `ctrl.name`
 *     khi mã không tồn tại hoặc `api_code` lệch).
 *
 * File KHÔNG import gì để test node chạy được trên chính mã nguồn này.
 */

/**
 * Mã listinfo mà màn hình này muốn mượn hành vi. `null` = không mượn của ai, dùng hành vi chuẩn.
 *
 *   useStandardApi = true   -> null (THẮNG mọi khai báo khác)
 *   listinfoCode có giá trị -> chính nó
 *   không khai gì           -> moduleCode (tương thích ngược với các cấu hình đang chạy)
 */
function resolveListinfoCode(config) {
	const c = config || {};
	if (c.useStandardApi === true) return null;
	const explicit = typeof c.listinfoCode === 'string' ? c.listinfoCode.trim() : '';
	if (explicit) return explicit;
	const fallback = typeof c.moduleCode === 'string' ? c.moduleCode.trim() : '';
	if (fallback) return fallback;
	const code = typeof c.code === 'string' ? c.code.trim() : '';
	return code || null;
}

/**
 * Header để gửi kèm lời gọi API. KHÔNG có mã thì trả về object RỖNG chứ không phải `{"Listinfo-Code": ""}`
 * — gửi chuỗi rỗng là server vẫn thấy header và đi vào nhánh xử lý mã, khác hẳn với "không gửi gì".
 */
function listinfoHeaders(config) {
	const code = resolveListinfoCode(config);
	return code ? { "Listinfo-Code": code } : {};
}

export { resolveListinfoCode, listinfoHeaders };
